const model = {
  portugues: {
    zoom: 'Zoom',
    saveBellaCloud: 'Salvar no BellaCloud',
    share: 'Compartilhe',
    download: 'Download',
    resolution: 'Resolução',
    sessions: 'Partes',
    questionTitle: 'Confira a entrevista que o Bella fez com a modelo:',
    navBar: [{name: 'Fotos', val: 1, path: 'photo'}, {name:'Videos' , val: 2, path: 'video'}, {name: 'Lives', val: 6, path: 'live-videos'}, {name : 'Perfil', val: 3, path: 'perfil'}, {name: 'Wallpapers', val: 4, path: 'wallpaper'}, {name: 'Créditos', val: 5, path: 'credits'}],
    subscribeNow: 'Assine agora',
    soon: 'Em breve',
    addAlbum: 'Adicionar',
    newAlbum: 'Novo álbum',        
    saveAlbumInfo: 'Clique no álbum para adicionar ou remover item',
    titleModalPlan: 'Ainda não é sócio?',
    subtitleModalPlan: 'Escolha o melhor plano para você e assine agora mesmo!',
    textBodyModalPlan: 'Escolha o seu plano:',
    footer1ModalPlan: 'Já é sócio?',
    footer2ModalPlan: 'Faça seu Login',
    wallpaper: 'Escolha o seu wallpaper:',
    quality: 'Qualidade',
    viewProfile: 'Veja Mais'
  },
  ingles: {
    zoom: 'Zoom',
    saveBellaCloud: 'Save to BellaCloud',
    share: 'Share',
    download: 'Download',
    resolution: 'Quality',
    sessions: 'Sessions',
    questionTitle: 'Check out the interview that Bella did with the model:',
    navBar: [{name: 'Photos', val: 1, path: 'photo'}, {name:'Videos' , val: 2, path: 'video'}, {name: 'Lives', val: 6, path: 'live-videos'}, {name : 'Profile', val: 3, path: 'perfil'}, {name: 'Wallpapers', val: 4, path: 'wallpaper'}, {name: 'Credits', val: 5, path: 'credits'}],
    subscribeNow: 'Subscribe now',
    soon: 'Soon',
    addAlbum: 'Add',
    newAlbum: 'New album',        
    saveAlbumInfo: 'Click on the album to add or remove item',
    titleModalPlan: 'Not a member yet?',
    subtitleModalPlan: 'Choose the best plan for you and subscribe right now!',
    textBodyModalPlan: 'Choose your plan:',
    footer1ModalPlan: 'Already a member?',
    footer2ModalPlan: 'Log in',
    wallpaper: 'Choose your wallpaper:',
    quality: 'Quality',
    viewProfile: 'See More'    
  }
}

export default model
